import i from 'i18next'

import Panel from '~/components/Panel'

import { useRequestAds } from '../../hooks/useRequestAds'
import BrandPage from './BrandPage'
import Category from './Category'
import ProductPage from './ProductPage'
import Search from './Search'

const ContextSettings = () => {
  const { context } = useRequestAds()

  const renderContextComponent = () => {
    switch (context) {
      case 'search':
        return <Search />

      case 'category':
        return <Category />
      case 'product_page':
        return <ProductPage />

      case 'brand_page':
        return <BrandPage />

      default:
        return null
    }
  }

  return (
    <Panel title={i.t('rm:Configurations')}>{renderContextComponent()}</Panel>
  )
}

export default ContextSettings
